module.exports = __webpack_public_path__ + "static/media/facebook-login.90306486.svg";